module.exports = __webpack_public_path__ + "img/black.0b37cba4.svg";